var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KITSCombo',{attrs:{"propertyName":"Value","propertyID":"Key","items":_vm.items,"value":_vm.item},on:{"input":_vm.inputEvent}})
}
var staticRenderFns = []

export { render, staticRenderFns }